import { render, staticRenderFns } from "./FileCopyOutlined.vue?vue&type=template&id=338ae1c0&"
import script from "./FileCopyOutlined.vue?vue&type=script&lang=js&"
export * from "./FileCopyOutlined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports